<div class="p-4 bg-third-level rounded-lg mt-6" *transloco="let t">
  <h3 class="text-lg font-semibold mb-3 text-white">
    {{ t('project.steps.rfd.useCase.summary') }}
  </h3>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
    <div>
      <p class="text-sm text-gray-400 mb-1">
        {{ t('project.steps.rfd.useCase.totalUseCases') }}
      </p>
      <p class="text-2xl font-bold text-white m-0">
        {{ totalUseCases() }}
      </p>
    </div>
    <div>
      <p class="text-sm text-gray-400 mb-1">
        {{ t('project.steps.rfd.useCase.includedInDemo') }}
      </p>
      <p class="text-2xl font-bold text-blue-400 m-0">
        {{ includedUseCases() }}
      </p>
    </div>
    <div>
      <p class="text-sm text-gray-400 mb-1">
        {{ t('project.steps.rfd.useCase.plannedDuration') }}
      </p>
      <p class="text-2xl font-bold text-white m-0">
        {{ formatDuration(plannedDuration()) }}
      </p>
    </div>
    <div>
      <p class="text-sm text-gray-400 mb-1 flex items-center gap-2">
        {{ t('project.steps.rfd.useCase.actualDuration') }}
        <app-directus-tooltip
          tooltipKey="project.steps.rfd.useCase.actualDuration.tooltip"
          tooltipStyleClass="tooltip-bg-second-level"
        ></app-directus-tooltip>
      </p>
      <p
        class="text-2xl font-bold m-0"
        [class.text-green-400]="durationDifference() <= 5"
        [class.text-red-400]="durationDifference() > 5"
      >
        {{ formatDuration(actualDuration()) }}
      </p>
    </div>
  </div>
</div>
